import React from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';

// Multibrand-UI Components
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import CaretRight from '@zg-rentals/multibrand-ui/lib/icons/CaretRight';

import numberUtils from 'app/shared/utils/numberUtils';
import InquiryType from 'app/shared/components/leadsForListing/InquiryType';

// Stylesheets
import './style.scss';

const propTypes = {
    leadData: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        ref: PropTypes.string,
        dateSaved: PropTypes.string,
    }),
    permanent: PropTypes.bool,
    isMultifamily: PropTypes.bool,
};

const defaultProps = {
    leadData: {
        id: '',
        name: '',
        ref: '',
        dateSaved: '',
    },
    permanent: false,
    isMultifamily: false,
};

const LeadForListingItem = ({
    leadData,
    permanent,
    isMultifamily,
    isFirstInList,
    handleLeadClick,
}) => {
    const {
        name,
        dateSaved,
        isPhoneLead,
        phone,
    } = leadData;

    const readStatus = leadData.inbox.status.read;

    const leadDateSaved = `${format(new Date(dateSaved), 'M/DD/YYYY')}`;

    const handleClick = () => {
        handleLeadClick(leadData);
    };

    return (
        <div onClick={handleClick}>
            <StyledContainer
                className="LeadForListingItem"
                borderBottom={true}
                borderTop={isFirstInList}
                borderColor="default"
                borderWidth="thin"
            >
                <div className="LeadForListingItem-left-container">
                    <InquiryType
                        permanent={permanent}
                        isMultifamily={isMultifamily}
                        isPhoneLead={isPhoneLead}
                    />

                    <Text type="body" emphasize={true}>
                        {isPhoneLead ? numberUtils.formatPhoneNumber(phone) : name}
                    </Text>

                    <Text type="body-small" thin={true}>
                        {leadDateSaved}
                    </Text>
                </div>

                {!readStatus && (
                    <Text
                        className="LeadForListingItem-readStatus"
                        emphasize={true}
                        uppercase={true}
                        type="body-tiny"
                    >
                        {' '}
                        NEW
                        {' '}
                    </Text>
                )}

                <CaretRight className="LeadForListingItem-Icon" size="md" />
            </StyledContainer>
        </div>
    );
};

LeadForListingItem.propTypes = propTypes;
LeadForListingItem.defaultProps = defaultProps;

export default LeadForListingItem;
